module.exports = __webpack_public_path__ + "img/china-map.b11954e1.webp";